import { SVGProps, Ref, forwardRef } from 'react';

export const CartOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.468 5.332H0l.49 5.157h.002C.866 13.866 2.288 15 6.076 15H9.92c3.788 0 5.21-1.133 5.584-4.511h.002l.49-5.157h-2.469L10.22 1l-1.112.85 2.658 3.482H4.23L6.888 1.85 5.775 1zm-.585 5.003-.01-.096-.334-3.507h12.918l-.334 3.507-.01.096c-.172 1.552-.552 2.226-.999 2.586-.488.393-1.377.68-3.194.68H6.076c-1.817 0-2.706-.287-3.194-.68-.447-.36-.827-1.034-.999-2.586"
                fill="currentColor"
            />
        </g>
    </svg>
));
CartOutlinedSize16Glyph.displayName = 'CartOutlinedSize16Glyph';
